import { h } from "preact";

import AppLayout from "../components/AppLayout.jsx";
import Button from "../components/Button.jsx";
import i18n from "../i18n.js";

export default function NotFoundPage({ headless }) {
  const content = (
    <div class="row">
      <div class="col s12 l6 push-l6 center">
        <img src="/images/404.svg" class="t-h1--margin pb-0 page-illu" />
      </div>

      <div class="col s12 l6 pull-l6">
        <h1 class="t-h1 t-h1--margin">{i18n.t("pages.notFound.title")}</h1>
        <p class="t-h4 mb-48 color-shades-grey">
          {i18n.t("pages.notFound.description")}
        </p>

        <p>
          <Button to="/tasks" secondary>
            {i18n.t("pages.notFound.action")}
          </Button>
        </p>
      </div>
    </div>
  );

  if (headless) {
    return content;
  }
  return (
    <AppLayout title={i18n.t("pages.titles.notFound")}>{content}</AppLayout>
  );
}
